<template>
  <v-switch
    dense
    v-model="pscThemeDark"
    hint="Cambie el tema de la aplicación"
    label="Tema obscuro"
    persistent-hint
  ></v-switch>
</template>

<script>
export default {
  name: 'SwitchTheme',
  data() {
    return {
      pscThemeDark: null
    } 
  },
  created() {
    const pscTheme = (localStorage.getItem('pscThemeDark') || '') === 'true'
    this.pscThemeDark = !!pscTheme
  },
  watch: {
    pscThemeDark(value){
      this.$vuetify.theme.dark = !!value
      localStorage.setItem('pscThemeDark', !!value)
    }
  }
}
</script>